import * as React from 'react';
import React__default from 'react';

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var ConnectComponentsContext = /*#__PURE__*/React.createContext(null);
ConnectComponentsContext.displayName = 'ConnectComponents';
var ConnectComponentsProvider = function ConnectComponentsProvider(_ref) {
  var connectInstance = _ref.connectInstance,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ConnectComponentsContext.Provider, {
    value: {
      connectInstance: connectInstance
    }
  }, children);
};
var useConnectComponents = function useConnectComponents() {
  var context = React.useContext(ConnectComponentsContext);
  if (!context) {
    throw new Error("Could not find Components context; You need to wrap the part of your app in an <ConnectComponentsProvider> provider.");
  }
  return context;
};

var useCreateComponent = function useCreateComponent(tagName) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    component = _React$useState2[0],
    setComponent = _React$useState2[1];
  var _useConnectComponents = useConnectComponents(),
    connectInstance = _useConnectComponents.connectInstance;
  var wrapperDivRef = React.useRef(null);
  // We set width to 100% to preserve this functionality aspect of embedded components even though
  // we are introducing a wrapper div for this element
  // https://docs.corp.stripe.com/connect/get-started-connect-embedded-components#width-and-height
  var wrapper = /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    },
    ref: wrapperDivRef
  });
  React.useLayoutEffect(function () {
    if (wrapperDivRef.current !== null && component === null) {
      var newComponent = connectInstance.create(tagName);
      setComponent(newComponent);
      if (newComponent !== null) {
        try {
          newComponent.setAttribute('reactSdkAnalytics', '3.3.8');
        } catch (e) {
          console.log('Error setting React Sdk version with error message: ', e);
        }
        while (wrapperDivRef.current.firstChild) {
          wrapperDivRef.current.removeChild(wrapperDivRef.current.firstChild);
        }
        wrapperDivRef.current.appendChild(newComponent);
      }
    }
  }, [connectInstance, tagName]);
  return {
    wrapper: wrapper,
    component: component
  };
};

var useUpdateWithSetter = function useUpdateWithSetter(component, value, onUpdated) {
  React__default.useEffect(function () {
    if (!component) return;
    onUpdated(component, value);
  }, [component, value, onUpdated]);
};

var ConnectPayments = function ConnectPayments() {
  var _useCreateComponent = useCreateComponent('payments'),
    wrapper = _useCreateComponent.wrapper;
  return wrapper;
};
var ConnectPayouts = function ConnectPayouts() {
  var _useCreateComponent2 = useCreateComponent('payouts'),
    wrapper = _useCreateComponent2.wrapper;
  return wrapper;
};
var ConnectPaymentDetails = function ConnectPaymentDetails(_ref) {
  var payment = _ref.payment,
    onClose = _ref.onClose;
  var _useCreateComponent3 = useCreateComponent('payment-details'),
    wrapper = _useCreateComponent3.wrapper,
    paymentDetails = _useCreateComponent3.component;
  useUpdateWithSetter(paymentDetails, payment, function (comp, val) {
    return comp.setPayment(val);
  });
  useUpdateWithSetter(paymentDetails, onClose, function (comp, val) {
    return comp.setOnClose(val);
  });
  return wrapper;
};
var ConnectAccountOnboarding = function ConnectAccountOnboarding(_ref2) {
  var onExit = _ref2.onExit,
    recipientTermsOfServiceUrl = _ref2.recipientTermsOfServiceUrl,
    fullTermsOfServiceUrl = _ref2.fullTermsOfServiceUrl,
    privacyPolicyUrl = _ref2.privacyPolicyUrl,
    skipTermsOfServiceCollection = _ref2.skipTermsOfServiceCollection,
    collectionOptions = _ref2.collectionOptions;
  var _useCreateComponent4 = useCreateComponent('account-onboarding'),
    wrapper = _useCreateComponent4.wrapper,
    onboarding = _useCreateComponent4.component;
  useUpdateWithSetter(onboarding, recipientTermsOfServiceUrl, function (comp, val) {
    return comp.setRecipientTermsOfServiceUrl(val);
  });
  useUpdateWithSetter(onboarding, fullTermsOfServiceUrl, function (comp, val) {
    return comp.setFullTermsOfServiceUrl(val);
  });
  useUpdateWithSetter(onboarding, privacyPolicyUrl, function (comp, val) {
    return comp.setPrivacyPolicyUrl(val);
  });
  useUpdateWithSetter(onboarding, skipTermsOfServiceCollection, function (comp, val) {
    return comp.setSkipTermsOfServiceCollection(val);
  });
  useUpdateWithSetter(onboarding, collectionOptions, function (comp, val) {
    return comp.setCollectionOptions(val);
  });
  useUpdateWithSetter(onboarding, onExit, function (comp, val) {
    return comp.setOnExit(val);
  });
  return wrapper;
};
var ConnectAccountManagement = function ConnectAccountManagement(_ref3) {
  var collectionOptions = _ref3.collectionOptions;
  var _useCreateComponent5 = useCreateComponent('account-management'),
    wrapper = _useCreateComponent5.wrapper,
    accountManagement = _useCreateComponent5.component;
  useUpdateWithSetter(accountManagement, collectionOptions, function (comp, val) {
    return comp.setCollectionOptions(val);
  });
  return wrapper;
};
var ConnectNotificationBanner = function ConnectNotificationBanner(_ref4) {
  var collectionOptions = _ref4.collectionOptions;
  var _useCreateComponent6 = useCreateComponent('notification-banner'),
    wrapper = _useCreateComponent6.wrapper,
    notificationBanner = _useCreateComponent6.component;
  useUpdateWithSetter(notificationBanner, collectionOptions, function (comp, val) {
    return comp.setCollectionOptions(val);
  });
  return wrapper;
};
var ConnectDocuments = function ConnectDocuments() {
  var _useCreateComponent7 = useCreateComponent('documents'),
    wrapper = _useCreateComponent7.wrapper;
  return wrapper;
};
var ConnectPayoutsList = function ConnectPayoutsList() {
  var _useCreateComponent8 = useCreateComponent('payouts-list'),
    wrapper = _useCreateComponent8.wrapper;
  return wrapper;
};
var ConnectBalances = function ConnectBalances() {
  var _useCreateComponent9 = useCreateComponent('balances'),
    wrapper = _useCreateComponent9.wrapper;
  return wrapper;
};

var useAttachAttribute = function useAttachAttribute(component, attribute, value) {
  React__default.useEffect(function () {
    if (!component) return;
    if (value !== undefined) {
      component.setAttribute(attribute, value.toString());
    } else {
      // RemoveAttribute is a no-op if the attribute is not present
      component.removeAttribute(attribute);
    }
  }, [component, attribute, value]);
};

var ConnectElementEventNames;
(function (ConnectElementEventNames) {
  ConnectElementEventNames["exit"] = "exit";
  ConnectElementEventNames["close"] = "close";
  ConnectElementEventNames["instantPayoutCreated"] = "instantpayoutcreated";
})(ConnectElementEventNames || (ConnectElementEventNames = {}));
var useAttachEvent = function useAttachEvent(component, eventName, listener) {
  React__default.useEffect(function () {
    if (component) {
      component.addEventListener(eventName, listener);
    }
    return function () {
      if (component) {
        component.removeEventListener(eventName, listener);
      }
    };
  }, [component, eventName, listener]);
};

export { ConnectAccountManagement, ConnectAccountOnboarding, ConnectBalances, ConnectComponentsProvider, ConnectDocuments, ConnectElementEventNames, ConnectNotificationBanner, ConnectPaymentDetails, ConnectPayments, ConnectPayouts, ConnectPayoutsList, useAttachAttribute, useAttachEvent, useConnectComponents, useCreateComponent, useUpdateWithSetter };
